export default {
  menu: {
    aboutUs: "關於我們",
    tnWorld: "TN WORLD",
    NFTs: "NFTs",
    roadMap: "RoadMap",
    team: "社區夥伴",
    tnPass: "TN PASS"
  },
  startVideo: "文明，因我们而生",
  openScene: {
    text: "TraditioNow \n 是鏈接Web3與現實世界的\n文藝復興平臺",
    tips: "劃動鼠標\n發現更多奧秘"
  },
  introOne: {
    title: "TraditioNow Pass",
    paragraph: "TraditioNow Pass 是這場文藝復興的尊貴通行證，持有者將率先點亮通往全新世界的通道，並成為首批文明創造者。",
    cardsTil: {
      id: "身份標識",
      news: "一手信息",
      airdrop: "資產空投",
      access: "社區權限",
      vipPass: "尊贵通道"
    }
  },
  introTwo: {
    title: "在TN World，一起創造無限可能",
    paragraph: "TN World 是屬於文明創造者的世界，他们收集各種时间沉淀下来的文明結晶，进行全新的创造，从而不断丰富着这个世界。文明的力量被再度激活，它為人们帶來探索的勇氣、創造的靈感和自我的觉醒。這是一個可以容納所有創意、夢想、愛與自我價值的世界。"
  },
  introThree: {
    title: "文明結晶收集，即將開啟",
    paragraph: "透過一扇扇神秘之門，我們收集各種時間所沉澱的文明結晶，為新世界注入能量。伴隨著這些神秘之門依次被打開，嶄新的世界將漸漸浮現於我們的眼前。",
    card1: "向神跳舞<br/>一切文化的原點，都是信仰",
    card2: "敬請期待",
    card3: "敬請期待",
    card4: "敬請期待",
    card5: "敬請期待",
    card6: "敬請期待"
  },
  cardList: {
    title: "集結文明創造者，共創文明新紀元",
    cards: {
      "01": {
        mark: "階段1:",
        title: "",
        text1: "尋找同盟夥伴，他們因為「相信而看見」，他們願意為這場鏈接web3與現實世界的文藝復興帶來第一束光。"
      },
      "02": {
        mark: "階段2",
        title: "",
        text1: "圍繞人類文明，用跨地域、跨種族、 跨類型的創作實驗，為開啟新世界的通道註入能量。"
      },
      "03": {
        mark: "階段3",
        title: "",
        text1: "有關「時間」的新世界正式開啟，文明宇宙的邊界將被不斷拓展。",
        text2: "三重力量化身為新文明世界的三大「神蹟」，它們將有效助力社區將文明之光不斷傳衍，並通過我們共同的努力而變得完善。",
        text3: "讓文明誕生於每個人的參與中。"
      }
    },
    tips: "滑動或點擊數字，探索文明進程"
  },
  artistList: {
    title: "OUR FRIENDS",
    artistIntro: {
      "01": {
        name: "Itay Ohaly",
        intro: "以色列知名產品設計師"
      },
      "02": {
        name: "Christoph Brach",
        intro: "德國設計協會特邀評審"
      },
      "03": {
        name: "Gijs Bakker",
        intro: "荷蘭國寶級設計師,後現代主義思潮的推動者"
      },
      "04": {
        name: "Kim Buck",
        intro: "丹麥國寶級首飾藝術家設計師"
      },
      "05": {
        name: "JUJU WANG",
        intro: "光影藝術家"
      },
      "06": {
        name: "Lisa O’Sullivan",
        intro: "國際知名產品設計師，歐洲工業設計領域傑出人物"
      },
      "07": {
        name: "Martí Guixé",
        intro: "西班牙籍產品設計大師,世界食品設計先驅"
      },
      "08": {
        name: "Nendo ",
        intro: "日本設計大師，美國《新聞周刊》評選的「最受世界尊敬的 100 位日本人」之一"
      },
      "09": {
        name: "倉本仁",
        intro: "日本GOOD DESIGN設計大奬評審委員"
      },
      "10": {
        name: "Thomas Widdershoven",
        intro: "荷蘭艾因霍芬設計學院院長"
      },
      "11": {
        name: "Tjeerd Veehoven",
        intro: "荷蘭材料學家、德國包豪斯設計學院教授"
      },
      "12": {
        name: "吉行良平",
        intro: "京都高等美術設計學院指導老師"
      },
      "13": {
        name: "井出八州",
        intro: "日本知名獨立產品設計師"
      },
      "14": {
        name: "寺山紀彥",
        intro: "日本著名空間及室內設計師"
      },
      "15": {
        name: "中村 穣",
        intro: "日本珠寶品牌Januka創始人"
      },
      "16": {
        name: "Simon Kämpfer",
        intro: "歐洲產品、室內權威設計師、歐洲家具設計師代表人物"
      },
      "17": {
        name: "Tom Dixon",
        intro: "設計宗師，大英帝國勛章OBE獲得者"
      },
      "18": {
        name: "Odo Fioravanti",
        intro: "工業設計界的奧斯卡獎—意大利金圓規獎4次獲得者"
      },
      "19": {
        name: "Satyendra Pakhalé",
        intro: "國際知名全能工業設計大師"
      },
      "20": {
        name: "Stefan Sagmeister",
        intro: "格萊美設計獎獲得者"
      }
    },
    tips: "无特殊顺序"
  },
  foot: {
    policy: "隱私政策",
    terms: "服務條款"
  },
  policy: {
    paragraph1: {
      title: "私隱政策",
      text: "通過訪問traditionow.xyz (“本網站”)，您接受本私隱政策中所述的做法，並同意我們為本私隱政策所述的目的，以及為提供或適當管理本網站所合理必要的任何其他目的，收集和使用您的個人資料。本私隱政策中未定義的大寫術語與《服務條款》相同術語的含義一致。"
    },
    paragraph2: {
      title: "我們收集什麼資料以及我們如何收集資料?",
      text1: "如果您只是流覽本網站的公共區域，我們不會收集有關您的任何個人資料。 \n 但是，我們會在您使用本服務時收集有關您的資訊，包括您在訪問我們的內容時提供的資訊。我們收集的資訊類別包括:",
      ul1: {
        "0": "交易資料，與鑄造、購買、銷售和轉讓非同質化代幣(“NFT”)有關的資料，包括您的數位或加密貨幣錢包的資訊以及交易的購買價格、發生日期和地點；",
        "1": "連絡人資料，包括您的電子郵寄地址。您可以選擇自願向我們提供我們沒有要求的其他資訊，在這種情況下，您將對這些資訊單獨負責。"
      },
      text2: "此外，我們會在您使用本服務時自動收集您的資訊。我們自動收集的資訊類別包括：",
      ul2: {
        "0": "服務使用資料，包括與您使用的功能、您訪問的頁面、您流覽的時間以及您進入和退出頁面有關的資料；",
        "1": "設備資料，包括與您使用的設備或流覽器的類型、設備的操作軟體、互聯網服務提供者、設備的地區和語言設置以及設備識別字(如IP位址)有關的資料；",
        "2": "位置資料，包括非精確的位置資料（例如通過IP位址定位的位置，或指示城市或郵遞區號級別的資料)。"
      },
      text3: "我們也從其他來源收集資訊。我們收集資訊的來源包括：",
      ul3: {
        "0": "您與之互動的社交媒體平臺，包括我們的Twitter和Discord伺服器；",
        "1": "公開來源，包括處於公共領域的資料；",
        "2": "協力廠商服務，包括供應商提供的與支付、身份驗證、反洗錢（AML）、欺詐檢測和其他類似服務相關的支援服務。這些供應商有自己的條款和條件、私隱政策和cookie政策。如果他們是您相關資料的控制者，他們可能會直接與您聯繫，就他們的資料處理情形單獨向您提供建議。有關我們的資料處理或資料控制供應商的進一步資訊，請與我們聯繫。"
      }
    },
    paragraph3: {
      title: "我們如何處理收集到的資訊？",
      text1: "我們收集資料有很多原因。我們收集和使用資訊的目的包括：",
      ul: {
        "0": "向您提供服務；",
        "1": "防止和解決欺詐、對於政策或條款的違反、威脅或損害；",
        "2": "瞭解趨勢、使用和行為，包括通過跟蹤技術或調查，以做出業務和行銷決策；",
        "3": "與您溝通網站更新、安全警示、政策變動和其他交易消息；",
        "4": "個性化您的體驗，向您展示我們相信您會發現有趣的內容；",
        "5": "向您進行直接行銷及推廣；",
        "6": "為了履行我們必須承擔的法律義務，例如反洗錢(AML)調查；",
        "7": "根據您的指示達成您期望的目標。"
      },
      text2: "您的資訊可能會傳輸並提供給我們的授權方或關聯方使用。"
    },
    paragraph4: {
      title: "我們如何保證資料安全?",
      text: "我們有適當的安全措施以防止在我們控制下的資訊的丟失、濫用和更改。只有經過授權的員工、代理商和承包商（同意對資訊進行安全保密）才能訪問這些資訊。"
    },
    paragraph5: {
      title: "本私隱政策的更改",
      text: "我們保留隨時修改和重新發佈本私隱政策的權利。您繼續使用我們的服務表示您同意隨後發佈的私隱政策。如更改屬重大事項，我們可能向您發送電子郵件另行通知。"
    },
    paragraph6: {
      title: "與我們聯繫",
      text: "如果您對我們的資料操作有任何疑問，或在訪問本私隱政策時遇到任何困難，請通過電子郵件與我們聯繫[support@tnlabs.xyz]。"
    }
  },
  terms: {
    paragraph1: {
      title: "服務條款",
      text: "本服務條款，包括引用的任何政策、規則和其他條款(統稱“本條款”)，是您與TN Labs, INC（“我們”或“我們的”）之間具有法律約束力的協議。本條款將適用於您對我們網站traditionow.xyz（“本網站”）的使用，以及在本網站展示或通過本網站提供的任何內容、功能或服務，包括但不限於出售、購買、鑄造和展示非同質化代幣（“NFT”）（統稱為“服務”）的能力。在使用本網站或任何服務前，請仔細閱讀本條款。"
    },
    paragraph2: {
      title: "1. 接受本條款",
      text1: "通過訪問或使用本網站或服務，或在提供此選項時按一下接受這些條款，即表示您接受並同意接受這些條款的約束。除這些條款外，您對網站某些部分或方面的訪問和使用，或您訪問和/或使用某些服務的能力，可能要求您接受附加條款和條件（統稱“附加條款”）。附加條款系本條款的一部分。",
      text2: "本條款將指導您訪問和使用本網站和服務。使用本網站和/或任何服務，即表示您明確同意受本條款的約束。如果您不同意這些條款，請不要訪問或使用本網站或服務。"
    },
    paragraph3: {
      title: "2. 對條款的修改",
      text1: "如果對本條款有任何重大更改，我們將在網站上發佈通知。此類更改，無論是條款的修改、添加或刪除，將在相關通知中明確規定的時間生效，如果非重大更改，則將在本網站發佈時立即生效。請定期查看本條款的更改。在我們發佈對本條款的任何更改後，您繼續使用本網站和/或服務，即表示您接受並同意這些更改。"
    },
    paragraph4: {
      title: "3. 隱私政策",
      text1: "我們的隱私政策將指導處理我們在您使用本網站及/或服務時收集的所有個人資料。本隱私政策及其條款和規定系本條款的一部分。您必須同意本隱私政策才能使用本網站和/或服務。"
    },
    paragraph5: {
      title: "4. 帳戶訪問資訊；帳戶",
      text1: "如果需要您創建帳戶以訪問本網站和/或服務，您須對您的個人帳戶資訊（包括但不限於您的用戶名、密碼和作為我們安全措施所需的任何其他資訊）妥善保管，請勿向任何其他人或主體披露上述資訊。您確認您的帳戶為您的個人帳戶，並同意不向任何其他人或主體提供您的用戶名、密碼或其他安全資訊以訪問本網站和/或服務。任何未經授權的協力廠商訪問您的帳戶都可能導致您的帳戶和任何相關帳戶內的資金丟失或被盜。您理解並同意，我們將不負責管理和維護您帳戶的安全（您也不會要求我們對此負責）。您進一步理解並同意，我們不對您帳戶中的任何資金損失或對您帳戶的任何未經授權的訪問或使用負責(您也不會要求我們負責)。您同意立即通知我們任何未經授權訪問或使用您的用戶名或密碼或任何其他破壞安全性的行為。您同意對使用您的用戶名、密碼或其他安全資訊使用本網站和/或服務的任何行為負責。如您違反了本條款的任何規定，我們有權在任何時候禁用帳戶、用戶名、密碼或其他標識資訊，無論前述資訊是由您選擇的或是由我們提供的。",
      text2: "請注意，各個國家的法律要求可能會限制我們可以合法提供的產品和服務。因此，某些服務和/或本服務中的某些功能可能在一些司法管轄區域或地區或對某些用戶不可用或受限。您應知曉並遵守您訪問本服務時所在國家對訪問和使用本服務施加的任何限制和/或要求。我們保留在不事先通知的情況下，隨時自行決定更改、修改或施加有關訪問和使用服務的額外限制的權利。"
    },
    paragraph6: {
      title: "5. 使用限制",
      text1: "您僅為個人用途使用本網站、服務和所有相關內容。未經我們明確書面同意，您不得為任何商業目的轉載、複印、複製、出售、轉售、訪問或以其他方式利用本網站、服務或其任何部分。您不得試圖修改、反向工程、反編譯、反彙編或以其他方式減少或以可感知的方式試圖減少我們在提供本網站時使用的任何原始程式碼。"
    },
    paragraph7: {
      title: "6. 版權，商標及其它智慧財產權",
      text1: "在訪問和使用本網站和/或服務時，您同意遵守法律並尊重他人的智慧財產權。您同意，您應對任何個人資料內容（定義如下）違反任何相關法律或侵犯協力廠商權利的行為負全部責任。",
      text2: "本網站和服務的所有內容（不包括NFT和個人資料內容），包括文本、原始程式碼中的隱藏文本、商標、軟體、照片、視頻、圖像、圖形、音樂、視聽內容、播客、錄音、聲音或任何其他數字媒體，均為我們和/或我們的許可方所有，並受專利、版權、商標或其他專有權利的保護。此外，本網站的全部內容系《版权条例》下的汇集作品，我們對該等內容的選擇、協調、編排和改進享有版權。您向我們提供的任何有關本網站和/或服務的回饋均應被視為非機密。我們可以不受限制地自由使用這些資訊。",
      text3: "本網站和/或服務的所有商標、商號、商品外觀、標識和服務標章（統稱“商標”）均為其各自所有者的專有財產，在某些情況下包括我們和/或我們的合作夥伴公司。本網站、服務或本條款所載的任何內容均未暗示或以其他方式授予您使用我們或任何協力廠商擁有的任何商標或版權的許可或權利。",
      text4: "除本條款明確規定外，未經我們及相關版權所有人（如適用）的明確書面許可，您不得使用、修改、創建本網站或服務的衍生作品、複製、分發、再現、發佈、傳輸、展示、商業化或以任何其他方式利用本網站或服務的任何內容或材料。您承認並同意，您不會因訪問或使用本網站和/或服務而獲得任何所有權。"
    },
    paragraph8: {
      title: "7. 協力廠商網站",
      text1: "我們可能提供可連結和跳轉到與我們無關的、由其它方（“協力廠商網站”）維護、擁有或控制的網站、商品和/或服務，這些其他方可能位於不同國家且可能受不同監管和其它法律要求的約束。我們未審查與本網站或服務連結的所有協力廠商網站，且不對該協力廠商網站上提供的內容或服務負責，包括但不限於與該協力廠商網站相關的任何廣告、KYC流程、訂單處理和履行或支付條款。通過本網站或服務訪問協力廠商網站並不構成我們或我們的任何關聯公司對該協力廠商網站或其提供的內容或服務的認可。我們對該協力廠商網站的獨立政策或行為不承擔任何責任或義務，也不對該協力廠商網站的隱私措施負責。有關協力廠商網站的投訴、索賠、關注點或問題請直接向適當的協力廠商提出。"
    },
    paragraph9: {
      title: "8. 免責聲明",
      text1: "NFTS是無形的數字資產。它們僅依靠區塊鏈維護的所有權記錄而存在。NFT可能發生的任何所有權轉讓都發生在區塊鏈的去中心化帳本上。",
      text2: "我們不對任何損失向您負責，也不對包括但不限以下情形所導致的任何NFT的損失、損害或索賠負責：（i）軟體的任何類型的故障或異常（例如，錢包、損壞的錢包檔、智慧合約等）、區塊鏈（包括乙太坊網路）；（ii）您在使用本網站時可能遇到的任何通信失敗、中斷、錯誤、扭曲或延誤，無論其原因如何；（iii）使用者差錯，例如遺忘密碼、非正確交易或位址輸入錯誤;（iv）由於開發者或代理延遲報告（或沒有報告）區塊鏈網路的任何問題（包括分叉、技術節點問題或任何其他導致資金損失的問題）而造成的損失；（v）伺服器故障、互聯網故障或資料丟失；以及（vi）任何未經授權的協力廠商行為，包括但不限於通過病毒、網路釣魚、暴力脅迫或其他手段攻擊本網站或服務。",
      text3: "本網站和服務可能向您提供某些資訊，包括但不限於與NFT、加密貨幣和區塊鏈技術相關的資訊。所有這些資訊僅用於說明目的，所有此類資訊均基於“現狀”和“可獲得”的信息提供，您在此明確承認並同意，對此類資訊的任何使用或信賴均由您自行承擔風險。"
    },
    paragraph10: {
      title: "9. 不可抗力",
      text1: "如因超出我們合理控制範圍的行為或情形導致我們在履行本條款時的任何失敗或延誤，包括但不限於天災、洪水、火災、地震、爆炸、政府行為、禁運、制裁或其他監管規定、戰爭、入侵或敵對行為（不論是否宣戰），恐怖主義威脅或行為、暴動或其他內亂、國家緊急狀態、革命、暴動、流行病、大流行、封鎖、罷工或其他勞資糾紛（無論是否與涉及我們的員工）、電信故障或電力中斷等，我們將不對您承擔責任或負責，也不被視為我們違約或違反本條款。"
    },
    paragraph11: {
      title: "10. 管轄法律及爭議解決",
      text1: "本條款和您對網站和/或服務的使用由香港實體法律和程式法律管轄及解釋。",
      text2: "您與我們之間因本條款而產生的或與本條款有關的任何爭議、索賠或爭議將由具有強制力的、最終且具有約束力的個人仲裁（非集體仲裁）決定。仲裁由香港國際仲裁中心（HKIAC）執行。仲裁應遵守在提交仲裁時有效的香港國際仲裁中心仲裁規則（HKIAC仲裁規則）。除非雙方另有約定，否則將根據HKIAC仲裁規則委任一名仲裁員。仲裁將以英語進行。無論仲裁以何種方式進行，仲裁員都將出具一份合理的書面裁決以解釋裁決和裁決所依據的主要調查結果和結論（如有）。仲裁地點應為香港。雙方同意對仲裁進行保密。儘管有上述規定，在履行法律義務、保護或請求法律權利、或在善意的法律程式中執行裁決或對裁決提出異議可能需要披露的必要範圍內，一方可以披露保密資訊。本保密規定在本條款和根據本條款提起的任何仲裁終止後仍然有效。"
    },
    paragraph12: {
      title: "11. 其它",
      text1: "您承認並同意，我們不堅持或強制嚴格履行本條款的任何條款將不被解釋為我們對任何條款或權利的放棄。我們無需通知您，也無需您明確同意，即可在任何時候將本條款項下的權利和義務轉讓給任何方。如果本條款中的任何條款被視為非法、無效或因任何原因不可執行，則該條款應被視為與本條款分離，且不影響其他條款的有效性和可執行性。本條款以及在本條款中引用的所有其他檔共同構成雙方就服務達成的完整協定，並取代雙方此前就服務達成的任何協定。"
    }
  }
}
